import request from '@/utils/request'


export const sendSms = (data) => request.post('/apis/api/index/sendCode', data);  //发送验证码接口

export const login = (data) => request.post('/apis/api/login/do_login', data);  //验证码登录接口

export const pwdLogin = (data) => request.post('/apis/api/login/login', data);  //密码登录接口

export const verity = (data) => request.post('/apis/api/login/do_verity', data);  //验证身份

export const editPwd = (data) => request.post('/apis/api/users/editPassword', data);  //提交密码

export const loginOut = (data) => request.post('/apis/api/users/logout', data);  //退出登录接口
